var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fieldset',{class:{ 'fieldset--disabled': _vm.isDisabled }},[_vm._t("default",null,{"toggle":_vm.toggle,"show":_vm.visible})],2)}
var staticRenderFns = []

export { render, staticRenderFns }